<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <input class="form-control mr-sm-2"
                           v-model="search.name"
                           type="search"
                           placeholder="ชื่อวัสดุ"
                           aria-label="Search"/>
                    <select class="form-control mr-sm-2 w-25"
                            v-model="search.source_id">
                        <option value="">แหล่งที่มา</option>
                        <option value="1">ในประเทศ</option>
                        <option value="2">นอกประเทศ</option>
                    </select>
                    <date-picker
                        v-model="search.date"
                        :format="changeFormat"
                        class="w-25"
                        :lang="lang"
                        placeholder="วันที่นำเข้า">
                    </date-picker>&nbsp;&nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchFactorialMaterialImport"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;&nbsp;
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">วันที่นำเข้า</th>
                    <th scope="col">ชื่อวัสดุ</th>
                    <th scope="col">แหล่งที่มา</th>
                    <th scope="col">จำนวนนำเข้า</th>
                    <th scope="col">หมายเหตุ</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">วันที่อัพเดตล่าสุด</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in factorialMaterialImportList">
                    <td>
                        {{ data.created_at | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                        <template v-if="data.factorial_material_details">
                            {{ data.factorial_material_details.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.source_id">
                            <template v-if="data.source_id == 1">
                                ในประเทศ
                            </template>
                            <template v-else>
                                นอกประเทศ
                            </template>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.quantity">
                            {{ data.quantity | amount }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.note">
                            {{ data.note }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>-</template>
                        &nbsp;&nbsp;
                    </td>
                    <td>
                        {{ data.updated_at | moment("DD/MM/YYYY , H:mm:ss") }}
                    </td>
                    <td>
                        <a @click="showFactorialMaterialImportModal(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showModalDelete(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="factorialMaterialImportList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getFactorialMaterialImportList">
            </vue-pagination>
        </div>
        <br/>

        <b-modal
            hide-footer
            ref="import_data"
            id="import"
            title="เพิ่มวัตถุดิบเข้าคลัง">
            <factorial-material-import-modal @submit="saveEditImport">
            </factorial-material-import-modal>
        </b-modal>

        <!-- ----Modal Delete---- -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deleteImport"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalDelete">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--        <pre class="alert-primary">{{factorialMaterialImportList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import FactorialMaterialImportModal from "./FactorialMaterialImportModal";

export default {
    name: "factorial-material-import",
    components: {
        FactorialMaterialImportModal,
        VuePagination,
        DatePicker
    },
    created() {
        this.$store.dispatch("FactorialMaterialImport/setFactorialMaterialImport");
        this.$store.dispatch("FactorialMaterialImport/clearFormData");
        this.$store.dispatch("FactorialMaterialImport/clearSearch");
    },
    data() {
        return {
            event_submit: false,
            id: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            factorialMaterialImportList: state => {
                return state.FactorialMaterialImport.factorialMaterialImportList
            },
            dataPaginate: state => {
                return state.FactorialMaterialImport.dataPaginate;
            },
            search: state => {
                return state.FactorialMaterialImport.search
            },
        })
    },
    methods: {
        showModalDelete(id) {
            this.id = id
            this.$refs.delete_item.show();
        },
        hideModalDelete() {
            this.$refs.delete_item.hide();
        },
        showFactorialMaterialImportModal(id) {
            this.showFactorialMaterialData(id);
            this.$refs.import_data.show();
        },
        hideFactorialMaterialImportModal() {
            this.$refs.import_data.hide();
        },
        showFactorialMaterialData(id) {
            this.$store.dispatch("FactorialMaterialImport/showFactorialMaterialImportByID", id).then(data => {
                this.$store.dispatch("FactorialMaterial/showFactorialMaterialByID", data.factorial_id);
            });
        },
        showFactorialMaterialByID(id) {
            this.$store.dispatch("FactorialMaterialImport/showFactorialMaterialImportByID", id).then(data => {
                this.$router.push("/factorial-material-information")
            });
        },
        getFactorialMaterialImportList() {
            const page = this.dataPaginate.current_page;
            //paginate search
            if (this.event_submit) {
                //change date format
                if (this.search.date) {
                    this.search.date = moment(this.search.date).format("YYYY-MM-DD");
                } else {
                    this.search.date = "";
                }
                let data = {
                    page: page,
                    name: this.search.name,
                    source_id: this.search.source_id,
                    date: this.search.date
                };

                this.$store.dispatch('FactorialMaterialImport/search', data)
            }
            //paginate get data
            else {
                this.$store.dispatch("FactorialMaterialImport/setFactorialMaterialImport", page);
            }
        },
        searchFactorialMaterialImport() {
            this.event_submit = true;

            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }

            this.$store.dispatch('FactorialMaterialImport/search', this.search)
        },
        saveEditImport(submitData) {
            //console.log('submitData')
            //console.log(submitData)
            if (submitData != 0) {
                this.$store.dispatch("FactorialMaterialImport/saveFactorialMaterialImport", submitData).then(() => {
                    this.$store.dispatch("FactorialMaterialImport/clearFormData")
                    this.$store.dispatch("FactorialMaterial/setFactorialMaterial");
                    this.$store.dispatch("FactorialMaterialImport/setFactorialMaterialImport");
                })
            }
            this.hideFactorialMaterialImportModal();
        },
        deleteImport() {
            //console.log(this.id)
            this.$store.dispatch('FactorialMaterialImport/delete', this.id).then(() => {
                this.$store.dispatch("FactorialMaterialImport/setFactorialMaterialImport");
                this.hideModalDelete()
            })
        }

    }
}
</script>

<style scoped>

</style>
